module.exports = __webpack_public_path__ + "img/nabl_gallery2.51ddb691.jpg";